import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { PagingQuery } from 'tea-component';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { useIntl, history, getLocale } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getCountryFlag } from '@/pages/home/_config/countries';
// import { PHeatColumn, CountryColumn } from '../columns';
// import MarketTable from '../MarketTable';
// import FixedSubTable from '@/pages/intelligence/components/TableComponents/FixedSubTable';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  datamapPCConsoleFieldsPath,
  datamapMobileGameFieldsPath,
} from '@/pages/intelligence/utils/common';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';
import { getTagFilterColumns } from '@intelligence/v3/utils/sensorTowerTagColumns';

interface UpcomingTableProps extends TopchartTableProps {
  entityType: string;
  releaseTime: { startRelease: string; endRelease: string };
  filterValue?: IRecord<any>;
  gameDetailsLoading?: boolean;
  gameDetailsMapping?: IRecord<IRecord>;
  onTagClick?: (type: string, tag: string) => void;
}
export default function UpcomingMobileTable(props: UpcomingTableProps) {
  const {
    entityType,
    loading,
    records = [],
    tableTotal,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
    filterValue,
    gameDetailsLoading = true,
    gameDetailsMapping = {},
    onTagClick,
  } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric } = pageSortAttr || {};
  // const [expandedKeys, setExpandedKeys] = useState<any>([]);
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  // const [subTableWidth, setSubTableWidth] = useState<string | number>('auto');
  // const [expandedId, setExpandedId] = useState('');

  // const planOptionFilterOptions = [
  //   { value: 'All', text: formatMessage({ id: 'dbi_all' }) },
  //   { value: 'Global Initial Launch', text: formatMessage({ id: 'dbi_global_initial_launch' }) },
  //   { value: 'New Market Entry', text: formatMessage({ id: 'dbi_new_market_entry' }) },
  // ];

  // useEffect(() => {
  //   setExpandedKeys([]);
  // }, [loading]);

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const onClickGame = (gameId: string) => {
    history.push({
      pathname: getDetailGameOverviewPath(gameId, 'mobile'),
      state: {
        noMatch: true,
      },
    });
  };

  // const observeTableSize = (width: number) => {
  //   setSubTableWidth(width);
  // };

  return (
    <>
      {/* 如果没有排序 header-other 用个类名 有排序用这个 table-header */}
      {/* sub-table-fixed 子表格固定的类名 组件库修改 全局通用 */}
      <TopchartTable
        // observeTableSize={observeTableSize}
        recordKey={'app_id'}
        loading={loading}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        columns={[
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => (
              <TableCheckboxHeader
                selectList={selectList}
                tableSelectionAll={tableSelectionAll}
                disabled={loading || records.length === 0}
                onChange={(list, stats) => {
                  onTableCheckGame(list, stats);
                  setSelectList(list);
                }}
              />
            ),
            render: (cvm: any) => (
              <TableCheckboxRender
                selectList={selectList}
                cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
                disabled={getGameRankDetails(cvm?.rank).isDisabled}
                onChange={(list, status) => {
                  setSelectList(list);
                  onTableCheckGame(list, status);
                }}
              />
            ),
          },
          {
            key: 'gametitle',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                id={getGameRankDetails(cvm?.rank)?.rankText}
                cvm={{
                  img: cvm?.cover,
                  gametitle: cvm?.name,
                  countryIcon: getCountryFlag(cvm?.publisher_addr),
                  text: cvm?.publisher,
                }}
                rihgtClickToJumpHref={getDetailGameOverviewPath(cvm?.app_id, 'mobile')}
                onClick={() => {
                  onClickGame(cvm?.app_id);
                }}
              />
            ),
          },
          // CountryColumn(),
          // PHeatColumn({
          //   currentSortKey: currentSortMetric,
          //   currentSortValue: currentSortValue,
          //   onSortChage,
          // }),
          // {
          //   key: 'plan',
          //   align: 'center',
          //   width: 200,
          //   header: (
          //     <CloumsCenter width={200} align="left">
          //       <div className="header-other">
          //         {formatMessage({ id: 'dbi_top_plan' })}
          //       </div>
          //     </CloumsCenter>
          //   ),
          //   render: (cvm: any) => {
          //     const planName = planOptionFilterOptions?.find(item => item.value === cvm?.plan)?.text || ''
          //     return (
          //       <CloumsCenter width={200} align="left">
          //         {planName}
          //       </CloumsCenter>
          //     );
          //   },
          // },
          {
            key: 'release_time',
            align: 'center',
            width: 180,
            header: (
              <CloumsCenter width={180} align="left">
                <SortBy
                  align="left"
                  title={formatMessage({ id: 'dbi_release_date' })}
                  defaultKey={currentSortMetric}
                  defaultValue={currentSortValue}
                  list={[
                    {
                      key: `release_time_0`,
                      sortMetric: 'release_time',
                      text: formatMessage({ id: 'dbi_release_date' }),
                      title: formatMessage({ id: 'dbi_release_date' }),
                    },
                  ]}
                  onChange={onSortChage}
                  content={
                    <span>
                      {formatMessage({ id: 'dbi_info_release_time' })}
                      <span
                        className="cursor-pointer"
                        style={{ paddingLeft: 10, color: '#326FF0', cursor: 'pointer' }}
                        onClick={() => {
                          entityType === 'mobile'
                            ? history.push(datamapMobileGameFieldsPath)
                            : history.push(datamapPCConsoleFieldsPath);
                        }}
                      >
                        {formatMessage({ id: 'dbi_learnmore' })}
                      </span>
                    </span>
                  }
                />
              </CloumsCenter>
            ),
            render: (cvm: any) => (
              <CloumsCenter width={180} align="left">
                {/* {cvm.release_time} */}
                {cvm.release_time ? moment(cvm.release_time).format('YYYY-MM-DD') : '-'}
              </CloumsCenter>
            ),
          },
          ...getTagFilterColumns({
            filterValue,
            gameDetailsLoading,
            gameDetailsMapping,
            locale,
            formatMessage,
            onTagClick,
          }),
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.app_id);
            },
            formatMessage,
          }),
        ]}
        // expandableAddon={{
        //   expandedKeys,
        //   onExpandedKeysChange: (keys, { event, operateRecord }) => {
        //     setExpandedId(keys[0] ? keys[keys?.length - 1] : '');
        //     event.stopPropagation();
        //     setExpandedKeys(keys);
        //   },
        //   render(record: any) {
        //     return (
        //       <div
        //         style={{
        //           width: subTableWidth || 'auto',
        //         }}
        //       >
        //         <MarketTable
        //           data={record}
        //           countryList={record.markets ? record.markets.split(',') : []}
        //           gameId={expandedId}
        //           startDate={releaseTime?.startRelease}
        //           endDate={releaseTime?.endRelease}
        //         />
        //       </div>
        //     );
        //   },
        // }}
      />
    </>
  );
}
